export default "__VITE_ASSET__BJh1dVTQ__"